var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"role"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.logged_user.role.name))]),_c('div',{staticClass:"text"},[_c('ui-text',{attrs:{"text":_vm.logged_user.role.role_description}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }